module.exports = __webpack_public_path__ + "static/collaborate-sketch@2x-5b5269af79138465dabbb91b7f5c1ee1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/sketch/collaborate-sketch@2x.jpg
// module id = 446
// module chunks = 131293461488081 145262073310797 281043220932899